import React, { useState, useEffect, useRef } from "react";
import Database from "./services/Database";
import { Line } from "@ant-design/charts";
import {
  Space,
  List,
  PageHeader,
  Card,
  Button,
  DatePicker,
  Select,
  Row,
  Col
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import Moment from "moment";
import "./App.css";

const { RangePicker } = DatePicker;
const { Option } = Select;

const stations = [
  { name: 'Köbsiel', value: 'BW01' },
  { name: 'Törpersiel', value: 'BW02' },
  { name: 'Reinbüllsiel', value: 'BW03' },
  { name: 'Martjesiel', value: 'BW04' },
  { name: 'Adenbüllersiel', value: 'BW05' },
  { name: 'Tetenbüll', value: 'BW06' },
  { name: 'Schwatsiel', value: 'BW08' },
];

const App = () => {
  const [station, setStation] = useState("BW01");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [stationData, setStationData] = useState([]);
  const [loadingUpperWater, setLoadingUpperWater] = useState(false);
  const selectRef = useRef();

  const handleChangeStation = (station) => {
    setStation(station);
  };

  const handleChangeCalendar = (event) => {
    // Check if the input is two dates.
    if (event?.length === 2) {
      setStartDate(event[0]);
      setEndDate(event[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const loadStationData = async (station, startDate, endDate) => {
    setStationData([]);
    setLoadingUpperWater(true);
    const response = await Database.getStationData(station, startDate, endDate);
    setLoadingUpperWater(false);
    setStationData(response.measurements);
  };

  const handleClickOK = async () => {
    if (startDate && endDate) {
      loadStationData(station, startDate, endDate);
    }
  };

  const handleExport = async () => {
    await Database.export(startDate, endDate, stations);
  };

  useEffect(() => {
    // Make sure that the station is never null or undefined.
    if (!station) {
      setStation(selectRef.current.props.defaultValue);
    }
  }, [station]);

  const headerExtra = (
    <Space align="center">
      <Select
        style={{ width: '200px' }}
        ref={selectRef}
        defaultValue={stations[0].value}
        onChange={handleChangeStation}
      >
        {stations.map(station => (
          <Option key={station.name} value={station.value}>{station.name}</Option>
        ) )}
      </Select>
      <RangePicker onCalendarChange={handleChangeCalendar} />
      <Button loading={loadingUpperWater} type="primary" onClick={handleClickOK}>OK</Button>
      <Button icon={<DownloadOutlined />} onClick={handleExport}>Export</Button>
    </Space>
  );

  const data = [];

  for (const row of stationData) {
    data.push({
      time: row.time,
      value: row.lowerWater,
      category: 'Unterwasser'
    }, {
      time: row.time,
      value: row.upperWater,
      category: 'Oberwasser'
    });
  }

  console.log(data);

  return (
    <div className="app">
      <PageHeader
        ghost={false}
        title="DHSV Eiderstedt"
        subTitle="Pegelstände"
        onBack={() => {}}
        extra={headerExtra}
      />
      <main>
        <Card
          title="Pegelstände"
        >
          <Row gutter={[64, 0]}>
           <Col flex="auto">
              <Line
                data={data}
                xField="time"
                yField="value"
                seriesField="category"
                loading={loadingUpperWater}
                xAxis={{
                  label: {
                    formatter: (v) => Moment(v).format('DD.MM.YYYY hh:mm')
                  }
                }}
                yAxis={{
                  min: 3,
                  max: 6
                }}
                tooltip={{
                  formatter: (datum) => ({ name: datum.category, value: datum.value + "m" })
                }}
              />
            </Col>
            <Col flex="300px">
              <List
                header={<h4>Unterwasser</h4>}
                split={false}
                dataSource={data.filter(d => d.category === 'Unterwasser')}
                pagination={{
                  pageSize: 10
                }}
                renderItem={item => (
                  <>
                    <List.Item>
                      <div>{Moment(item.time).format('DD.MM.YYYY hh:mm')}</div>
                      <div>{item.value.toFixed(2)}m</div>
                    </List.Item>
                  </>
                )}
              />
            </Col>
            <Col flex="300px">
              <List
                header={<h4>Oberwasser</h4>}
                split={false}
                dataSource={data.filter(d => d.category === 'Oberwasser')}
                pagination={{
                  pageSize: 10
                }}
                renderItem={item => (
                  <>
                    <List.Item>
                      <div>{Moment(item.time).format('DD.MM.YYYY hh:mm')}</div>
                      <div>{item.value.toFixed(2)}m</div>
                    </List.Item>
                  </>
                )}
              />
            </Col>
          </Row>
        </Card>
      </main>
    </div>
  );
}

export default App;